<template>
  <div v-if="!!tourOperatorOfficeContacts" class="contacts">
    <div v-for="(phone, ix) in tourOperatorOfficeContacts.phoneNumbers"
         :key="`p${ix}`"
         class="contacts__phone"
         :class="{'contacts__phone_single': tourOperatorOfficeContacts.phoneNumbers.length < 2}">
      {{phone}}
    </div>
    <div v-for="(email, ix) in tourOperatorOfficeContacts.emailContacts"
         :key="`e${ix}`"
         class="contacts__email">
      <a :href="`mailto:${email}`">{{email}}</a>
    </div>
  </div>
  <div v-else class="contacts">
    <div class="data-waiting-animation contacts__phone contacts__phone_single">&nbsp;</div>
    <div class="data-waiting-animation contacts__email">&nbsp;</div>
  </div>
</template>

<script>
export default {
  props: {
    tourOperatorOfficeContacts: Object,
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.contacts {
  > * + * {
    margin-top: 4px;
  }
}

.contacts__phone {
  font-size: 16px;
  line-height: 20px;
  
  &.contacts__phone_single {
    font-size: 20px;
    line-height: 24px;
  }
}

.contacts__email {
  font-size: 16px;
  line-height: 20px;
}

.contacts__email a {
  color: var(--white);
}
</style>



